import CheckIcon from '@mui/icons-material/Check';
import LanguageIcon from '@mui/icons-material/Language';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { languageLabels, supportedLanguages, useLanguage } from '../i18n/language';

/**
 * The language switcher. Names are endonyms and never translated — somebody who has landed in a
 * language they do not read has to be able to find their own.
 */
export function LanguageMenu() {
  const { language, setLanguage } = useLanguage();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <Tooltip title={t('language.switcher')}>
        <IconButton
          size="small"
          aria-label={t('language.switcher')}
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <LanguageIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={anchorEl !== null} onClose={() => setAnchorEl(null)}>
        {supportedLanguages.map((code) => (
          <MenuItem
            key={code}
            selected={code === language}
            onClick={() => {
              setLanguage(code);
              setAnchorEl(null);
            }}
          >
            <ListItemIcon>{code === language ? <CheckIcon fontSize="small" /> : null}</ListItemIcon>
            <ListItemText>{languageLabels[code]}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
